import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { UseFormReturn } from 'react-hook-form';

import { TOption } from '@treezor/design-system';

import { IAllCardsFiltersFormFields } from '@/features/cards/store/types/agent-card.types';
import { PaymentBlockCardTypeCode } from '@/features/cards/store/models/card.model';

import { ISelectField } from '@/ui-kit/table-filters/filters.type';

export function mapAllCardsStatus(value: number | string) {
  return {
    lockStatus: Number(value),
  };
}

export function useAllCardsStatusField(methods: UseFormReturn<IAllCardsFiltersFormFields>, onChange): ISelectField {
  const { t } = useTranslation();

  const handleStatusChange = useCallback(
    (value: IAllCardsFiltersFormFields['status']) => {
      methods.setValue('status', value);
      onChange();
    },
    [onChange, methods],
  );

  const statusOptions: TOption[] = Object.keys(PaymentBlockCardTypeCode).map((status: string) => ({
    label: t(`monetics.card.status.${status}`),
    value: PaymentBlockCardTypeCode[status],
  }));
  const statusValue = statusOptions.find((option) => option.value === methods.watch('status'));

  return {
    value: statusValue,
    handleChange: handleStatusChange,
    options: statusOptions,
  };
}
